// Module
var code = `<!-- ko if: (!!embeddedSurvey && !!embeddedSurvey.currentPage) -->
<div data-bind="attr: { id: currentPageId }, template: { name: 'survey-page', data: embeddedSurvey.currentPage }">
</div>
<!-- /ko -->`;
// Exports
export default code;